import React from 'react';
import InvestmentLocations from '../InvestmentLocations';

import OverviewMap from 'oldAssets/images/static_pages/investment_locations/leipzig/overview-map-leipzig.svg';

import DHL from 'oldAssets/images/static_pages/investment_locations/leipzig/organizations/DHL.webp';
import Porsche from 'oldAssets/images/static_pages/investment_locations/leipzig/organizations/Porsche.webp';
import MDR from 'oldAssets/images/static_pages/investment_locations/leipzig/organizations/mdr.webp';

import UNI from 'oldAssets/images/static_pages/investment_locations/leipzig/organizations/UNI.webp';
import HTWK from 'oldAssets/images/static_pages/investment_locations/leipzig/organizations/HTWK.webp';
import FOM from 'oldAssets/images/static_pages/investment_locations/leipzig/organizations/FOM.webp';

import DHLLogo from 'oldAssets/images/static_pages/investment_locations/leipzig/organizations/dhl.svg';
import PorsheLogo from 'oldAssets/images/static_pages/investment_locations/leipzig/organizations/porsche.svg';
import MDRLogo from 'oldAssets/images/static_pages/investment_locations/leipzig/organizations/mdr.svg';

import UNILogo from 'oldAssets/images/static_pages/investment_locations/leipzig/organizations/uni-leipzig.svg';
import HTWKLogo from 'oldAssets/images/static_pages/investment_locations/leipzig/organizations/htwk.svg';
import FOMLogo from 'oldAssets/images/static_pages/investment_locations/leipzig/organizations/fom.svg';

import EmployersMap from 'oldAssets/images/static_pages/investment_locations/leipzig/employers-map-leipzig.webp';
import UniversitiesMap from 'oldAssets/images/static_pages/investment_locations/leipzig/universities-map-leipzig.webp';

import ExceptionPhoto from 'oldAssets/images/static_pages/investment_locations/leipzig/exception-leipzig.webp';

/*eslint max-lines-per-function: ["error", 200]*/
const BerlinPage = (props) => {
  const { work, universities, exception, overview } = props;

  const employersPhotos = [DHL, Porsche, MDR];
  const employersLogos = [DHLLogo, PorsheLogo, MDRLogo];

  const universitiesPhotos = [UNI, HTWK, FOM];
  const universitiesLogos = [UNILogo, HTWKLogo, FOMLogo];

  const context = require.context(
    'oldAssets/images/static_pages/investment_locations/leipzig/gallery', false, /.+\.webp$/);

  return (
    <InvestmentLocations
      { ...props }
      pageName="Leipzig"
      overview={{
        data: overview,
        map: OverviewMap,
        context,
        link: 'https://immobilien-tipps.wunderagent.de/das-bessere-berlin-waechst-und-waechst'
      }}
      work={{
        data: work,
        photos: employersPhotos,
        logos: employersLogos,
        map: EmployersMap
      }}
      universities={{
        data: universities,
        photos: universitiesPhotos,
        logos: universitiesLogos,
        map: UniversitiesMap
      }}
      exception={{
        data: exception,
        photo: ExceptionPhoto
      }}
    />);
};

export default BerlinPage;
